import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';

import type { VolunteerDropdownData } from './types/VolunteerDropdownData';

export const volunteerDropdownDataEn: VolunteerDropdownData = {
  search: {
    title: 'Volunteer',
    items: [
      {
        type: 'volop',
        title: 'Find Volunteer Opportunities',
        href: searchGetVolopsRoutePath({
          locale: I18nLocale.EN,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'organizations',
        title: 'Search Organizations',
        href: searchGetOrgsRoutePath({
          locale: I18nLocale.EN,
        }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        type: 'volunteer-resources',
        title: 'Volunteer Resources',
        description:
          'Tips and inspiration for finding the perfect volunteer opportunities.',
        href: '/en/volunteering-resources?pq=',
      },
      {
        type: 'recipes-for-action',
        title: 'Recipes for Action',
        description:
          'A collection of actionable ideas to make a positive impact in your community.',
        href: '/en/recipes-for-action?pq=',
      },
    ],
  },
};
